import gql from 'graphql-tag';

import { CommentFragment } from '../fragments';

export const EditComment_Mutation = gql`
    mutation EditCommentMutation(
        $input: EditCommentInput!
    ) {
        editComment(
            input: $input
        ) {
            comment {
                ...CommentFragment
            }
        }
    }
    ${CommentFragment}
`;
